module.exports = __webpack_public_path__ + "static/media/homeleftMobile.1dd65f18.png";